import { createAction } from 'redux-actions';

import { resetForm } from '@gef-ui/form-core/stream/transfer/control';

import { appendMode, REQUEST_SIZE } from 'constants/general';
import dialog from 'features/common/dialog';
import fetch from 'features/common/fetch';
import { SUBSELLER_SEARCH_FORM_NAME } from 'features/views/subsellerSearch/form';
import { generateCommonFetchActions, trimFormData } from 'utils';

import * as types from './actionTypes';
import { dialogError } from './constants';

export const reset = createAction(types.RESET);
export const saveResults = createAction(types.SAVE_RESULTS);
export const appendResults = createAction(types.APPEND_RESULTS);

const url = fetch.constants.urls.userList;
const fetchStore = `${fetch.constants.urls.userList}.subsellerSearch`;

export const resetCriteria =
	() =>
	(dispatch, getState, { sendControlNext }) => {
		dispatch(reset());
		dispatch(dialog.actions.close(dialogError));
		dispatch(fetch.actions.clearFetchStore(fetchStore));
		sendControlNext(SUBSELLER_SEARCH_FORM_NAME, resetForm());
	};

export const loadData =
	({ queryParams }, append = appendMode.SET) =>
	(dispatch) => {
		return dispatch(
			fetch.actions.get(url, {
				uniqueReqID: 'subsellerSearch',
				queryParams,
				onSuccess: [
					(response) => () => {
						const userList = response.body.data;
						if (append === appendMode.APPEND) {
							dispatch(appendResults(userList));
						} else {
							dispatch(saveResults(userList));
						}
					},
				],
			}),
		);
	};

export const submitForm =
	() =>
	async (dispatch, getState, { getFormData }) => {
		const data = await getFormData(SUBSELLER_SEARCH_FORM_NAME);
		const formData = trimFormData(data);

		const { subsellerFirstName, subsellerSurname, subsellerLogin } = formData;

		return dispatch(
			loadData({
				queryParams: {
					userHierarchy: 'subordinatePpz',
					login: subsellerLogin,
					surname: subsellerSurname,
					firstName: subsellerFirstName,
					size: REQUEST_SIZE,
					page: 0,
					sort: ['surname,asc'],
				},
			}),
		);
	};

export const { loadMore, loadPage, reload } = generateCommonFetchActions(loadData, fetchStore);
